// extracted by mini-css-extract-plugin
export default {"right_article":"index_right_article_68C7h","first_item":"index_first_item_MiKdy","item":"index_item_1WaCM","check_more":"index_check_more_Y3uET","assess":"index_assess_IpiQi"};